'use strict';

angular.module('ntmApp').factory('SplitHM', function () {

    function SplitHM(labelPattern) {
        var pattern = labelPattern;
        this.hours = null;
        this.minutes = null;

        this.isDefined = function () {
            return (this.hours || this.hours === 0) ||
                   (this.minutes || this.minutes === 0);
        };

        this.isPartlyDefined = function () {
            return (this.hours || this.hours === 0) ||
                (this.minutes || this.minutes === 0);
        };

        this.clear = function () {
            this.hours = null;
            this.minutes = null;
        };

        this.getLabel = function () {
            return pattern.format(this.hours, this.minutes);
        };
    }

    return (SplitHM);
});